// export class CloneCondition {
//   static readonly type = '[Contract.Condition] Clone Condition';
//   constructor(public conditionID: number, public copies: number = 1) {}
// }

export class DeleteCondition {
  static readonly type = '[Contract.Condition] Delete Condition';
  constructor(public conditionID: number) {}
}

export class RestoreCondition {
  static readonly type = '[Contract.Condition] Restore Condition';
  constructor(public conditionID: number) {}
}

export class AddCondition {
  static readonly type = '[Contract.Condition] Add Condition';
  constructor(public Condition: any) {}
}

export class UpdateCondition {
  static readonly type = '[Contract.Condition] Update Condition';
  constructor(public Condition: any) {}
}
